import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function TableCell(props, context) {
  const {
    children,
    className: classNameProp,
    component,
    sortDirection,
    numeric,
    isFaded,
    isTableHeadCell,
    padding,
    scope: scopeProp,
    variant,
    ...other
  } = props;

  const { table } = context;
  let Component;
  if (component) {
    Component = component;
  } else if (isTableHeadCell) {
    Component = 'th';
  } else {
    Component = table && table.head ? 'th' : 'td';
  }

  let scope = scopeProp;
  if (!scope && table && table.head) {
    scope = 'col';
  }

  const className = classNames(classNameProp, { 'is-faded': isFaded });

  let ariaSort = null;
  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return (
    <Component className={className} aria-sort={ariaSort} scope={scope} {...other}>
      {children}
    </Component>
  );
}

TableCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * If `true`, content will align to the right.
   */
  numeric: PropTypes.bool,
  /**
   * Sets the padding applied to the cell.
   */
  padding: PropTypes.oneOf(['default', 'checkbox', 'dense', 'none']),
  /**
   * Set scope attribute.
   */
  scope: PropTypes.string,
  /**
   * Set aria-sort direction.
   */
  sortDirection: PropTypes.oneOf(['asc', 'desc', false]),
  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: PropTypes.oneOf(['head', 'body', 'footer']),
};

TableCell.defaultProps = {
  numeric: false,
  padding: 'default',
};

TableCell.contextTypes = {
  table: PropTypes.object.isRequired,
};

export default TableCell;
